import mixins from 'vue-typed-mixins';

export const reCaptcha = mixins().extend({
	data() {
		return {
			reCaptchaResponse: '',
			reCaptchaError: false,
		};
	},
	computed: {
		reCaptchaSiteKey(): string {
			return this.$attrs.captchaid ?? ' ';
		}
	},
	methods: {
		handleSuccess(response: string): void {
			this.reCaptchaResponse = response;
			this.resetError();
		},
		handleError(): void {
			this.setError();
		},
		setError(): void {
			this.reCaptchaError = true;
		},
		resetError(): void {
			this.reCaptchaError = false;
		},
	}
});
